export default {
  selectSeatApprovals: (state) => state.seatApprovals.seatApprovals,
};
